var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_eye",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.143 36l-6.8-7.4c-4.4-5.1-9.8-8.7-15.4-10.6-7.9-2.6-16.7-2.6-24.6 0-5.7 1.9-11.1 5.6-15.6 10.7l-6.6 7.3c-2 2.2-2 5.6 0 7.9 0 0 5.5 6.2 7.3 8.3 3.4 3.9 7.2 6.8 11.4 8.6 5 2.2 10.3 3.3 15.7 3.3 4.2 0 8.3-.7 12.4-2 5.7-1.9 11-5.5 15.4-10.6l6.8-7.5c2-2.3 2-5.7 0-8zm-3 5.3l-6.8 7.5c-4 4.5-8.7 7.8-13.7 9.4-8.3 2.7-17.2 2.3-25.2-1.2-3.6-1.6-7-4.1-10-7.6-1.8-2.1-7.3-8.3-7.3-8.3-.7-.8-.7-1.9 0-2.6l6.6-7.4c4-4.6 8.8-7.9 13.8-9.6 7.1-2.3 15-2.3 22.1 0 5 1.6 9.7 4.9 13.7 9.4l6.8 7.5c.7 1 .7 2.1 0 2.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.643 23.2c-9.3 0-16.9 7.5-16.9 16.7s7.6 16.8 16.9 16.8c9.3 0 16.9-7.5 16.9-16.7s-7.6-16.8-16.9-16.8zm0 29.6c-7.1 0-12.9-5.7-12.9-12.8 0-7.1 5.8-12.8 12.9-12.8 7.1 0 12.9 5.7 12.9 12.8 0 7.1-5.8 12.8-12.9 12.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.9328c62335305d2769619fe12ffc783c.svg";
export { ForwardRef as ReactComponent };